/**
 * Status Icon Component.
 */
import * as React from 'react';

import { Colors } from 'theme/colors';
import { NakedIcon } from './naked';

import { Circle, IconContainer } from './styles';
import { VectorIcon, VectorIconProps } from './vectorIcons';

export enum AlertType {
  None = 'None',
  Error = 'Error',
  Success = 'Success',
  Warning = 'Warning',
}

const ALERTS: Alert = {
  [AlertType.None]: {},
  [AlertType.Error]: { name: 'exclamation' },
  [AlertType.Success]: { name: 'tick-large' },
  [AlertType.Warning]: { name: 'exclamation' },
};
const ALERT_ICON = 30;
const HEIGHT = 100;
const WIDTH = 100;

/**
 * Circular Icon for the status of an alert (i.e., Error, Success, Warning).
 *
 * @param props - Status Icon React props.
 */
export function StatusIcon(props: Props) {
  const { alertType, accentColor, icon, iconColor, circleColor, circleWidth, circleHeight } = props;
  const alertIcon = ALERTS[alertType];
  const Icon = icon || NakedIcon;
  const config: Partial<Mutable<VectorIconProps>> = {};
  const backgroundColor = circleColor || accentColor;

  if (!icon) {
    config.name = alertIcon.name;
  }

  return (
    <IconContainer>
      <Circle style={{ backgroundColor, height: circleHeight, width: circleWidth }}>
        <Icon {...config} size={ALERT_ICON} color={iconColor} height={HEIGHT} width={WIDTH} />
      </Circle>
    </IconContainer>
  );
}
StatusIcon.defaultProps = {
  accentColor: Colors.green,
  alertType: AlertType.None,
  circleHeight: 80,
  circleWidth: 80,
};

/**
 * Type definitions.
 */

interface AlertItem {
  /** Name of the icon */
  name?: string;
}

type Alert = Record<AlertType, AlertItem>;

interface Props {
  /** Color the status icon should be displayed in */
  accentColor?: string;
  /** Type of alert to be displayed */
  alertType: AlertType;
  /** Color of the icon container */
  circleColor?: string;
  /** Width of the icon circle */
  circleWidth?: number | undefined;
  /** Height of the icon circle */
  circleHeight?: number | undefined;
  /** Color of icons */
  iconColor?: Colors;
  /** An optional vector icon to display instead of the default */
  icon?: typeof VectorIcon;
}
